<div id="main" *ngIf="token!==''">
    <!-- <tableau-viz id="tableauViz"
      [src]="srcUrl"
      toolbar="bottom"
      [accesToken]="token"
      hide-tabs
    >
    </tableau-viz> -->
    <div class="viz-wraper" [ngStyle]="{ height: contentHeight + 'px' }">
    <tableau-viz id="tableauViz"
        [src]="srcUrl"
        [token]="token"
        toolbar="top">
    </tableau-viz>
    </div>
</div>
    
    